var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 1.5C15.7538 1.5 16.5 2.23597 16.5 3.14383L16.5 5.94994C16.5 6.8578 15.7538 7.59377 14.8333 7.59377H12.3333C11.4129 7.59377 10.6667 6.8578 10.6667 5.94994L10.6667 3.14383C10.6667 2.23597 11.4129 1.5 12.3333 1.5L14.8333 1.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16667 1.5C2.24619 1.5 1.5 2.23597 1.5 3.14383L1.50001 5.94994C1.50001 6.8578 2.2462 7.59377 3.16667 7.59377H5.66667C6.58715 7.59377 7.33334 6.8578 7.33334 5.94994L7.33333 3.14383C7.33333 2.23597 6.58714 1.5 5.66667 1.5L3.16667 1.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 10.4063C15.7538 10.4063 16.5 11.1422 16.5 12.0501V14.8562C16.5 15.764 15.7538 16.5 14.8333 16.5H12.3333C11.4129 16.5 10.6667 15.764 10.6667 14.8562L10.6667 12.0501C10.6667 11.1422 11.4129 10.4063 12.3333 10.4063H14.8333Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16667 10.4063C2.2462 10.4063 1.50001 11.1422 1.50001 12.0501L1.50001 14.8562C1.50001 15.764 2.2462 16.5 3.16668 16.5H5.66667C6.58715 16.5 7.33334 15.764 7.33334 14.8562L7.33334 12.0501C7.33334 11.1422 6.58715 10.4063 5.66667 10.4063H3.16667Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCategory);
export default __webpack_public_path__ + "static/media/all-category.e38e0fbce3639a95b67d6eef3179903c.svg";
export { ForwardRef as ReactComponent };